import { useQuery } from "@apollo/client";

import { GqlCourseSelectOption } from "~/__generated__";

import { CourseSelect_GetOptionsDocument } from "./useCourseSelect_GetOptions.generated";

export default function useCourseSelect_GetOptions() {
    const { data, loading, error } = useQuery(CourseSelect_GetOptionsDocument);

    return {
        loading,
        error,
        data: (data?.courseNameSelectOptions?.data ?? []) as GqlCourseSelectOption[],
    };
}
